import './S_TabsCard.scss';
import classNames from 'classnames';
import { PropsWithChildren, ReactElement } from 'react';

interface IProps {
  className?: string;
}

export const S_TabsCard = ({ children, className }: PropsWithChildren<IProps>): ReactElement => (
  <div className={classNames('s-tabs-card', className)}>{children}</div>
);
